import { API_BASE_URL } from '../firebase';
import { authService } from './authService';

const apiCall = async (endpoint, options = {}) => {
  const url = `${API_BASE_URL}/urlShortener${endpoint}`;
  const token = await authService.getCurrentUserToken();
  
  if (!token) {
    throw new Error('You must be signed in to perform this action');
  }

  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${token}`,
    ...options.headers,
  };

  const response = await fetch(url, {
    ...options,
    headers,
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({ error: 'Network error' }));
    throw new Error(errorData.error || `HTTP error! status: ${response.status}`);
  }

  return response.json();
};

export const urlService = {
  async createUrl(originalUrl) {
    return apiCall('/api/urls', {
      method: 'POST',
      body: JSON.stringify({ originalUrl }),
    });
  },

  async getUrls() {
    return apiCall('/api/urls');
  },

  async updateUrl(id, data) {
    return apiCall(`/api/urls/${id}`, {
      method: 'PUT',
      body: JSON.stringify(data),
    });
  },

  async deleteUrl(id) {
    return apiCall(`/api/urls/${id}`, {
      method: 'DELETE',
    });
  },
}; 